import { render, staticRenderFns } from "./Liveagent.vue?vue&type=template&id=6bde8e24"
import script from "./Liveagent.vue?vue&type=script&lang=js"
export * from "./Liveagent.vue?vue&type=script&lang=js"
import style0 from "./Liveagent.vue?vue&type=style&index=0&id=6bde8e24&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports